import React, { useLayoutEffect } from 'react';
import { toastr } from 'react-redux-toastr';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { Button } from 'reactstrap';
import { BUS_MAINTENANCE_STAY_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { clearItineraryArrivals, postBusMaintenanceStay } from '../../../../actions/mechanical-maintenance/BusMaintenanceStay';
import { tzNormalizeDate } from '../../../../utils/date';
import NewBusMaintenanceStayForm from './NewBusMaintenanceStayForm';

const formValuesSelector = getFormValues('NewBusMaintenanceStayForm');

const NewBusMaintenanceStay = ({
  breadcrumbs,
  dispatchPostBusMaintenanceStay,
  dispatchClearItineraryArrivals,
  busMaintenanceStayBuseList,
  dispatchChange,
}) => {

  useLayoutEffect(() =>
    () => {
      dispatchClearItineraryArrivals();
    }
    , []);

  const onSubmit = ({ busMaintenanceStayBuses }) => {

    const busMaintenance = busMaintenanceStayBuses.filter(bus => bus.select);

    if (busMaintenance.length === 0) {
      toastr.error(
        'Error',
        'Debe seleccionar al menos un bus para continuar.',
      );
      return;
    }

    let isValid = true;

    busMaintenance.forEach((bus) => {
      if (!bus.registeredBusId || !bus.originCityId || !bus.estimatedArrivalDate) {
        toastr.error(
          'Error',
          'Todos los campos son obligatorios para cada bus seleccionado.'
        );
        isValid = false;
      }
    });

    if (!isValid) return;

    const busMaintenanceStayList = busMaintenance.map((bus) => ({
      registeredBusId: bus.registeredBusId.value,
      originCityId: bus.originCityId.value,
      estimatedArrivalDate: bus.estimatedArrivalDate
        ? tzNormalizeDate({
          date: bus.estimatedArrivalDate
        })
        : null,
      itineraryId: bus.itineraryId,
      destinationCityId: bus.destinationCityId ? bus.destinationCityId.value : null,
      noArrivalTime: bus.noArrivalTime || false,
    }));

    const newFormValues = {
      busMaintenanceStayList,
    }


    dispatchPostBusMaintenanceStay(newFormValues);

  };

  const handleButtonClick = () => {
    if (!busMaintenanceStayBuseList || busMaintenanceStayBuseList.length === 0) {
      return;
    }

    const updatedBuses = busMaintenanceStayBuseList.map(bus => ({
      ...bus,
      select: true,
    }));

    dispatchChange('NewBusMaintenanceStayForm', 'busMaintenanceStayBuses', updatedBuses);

  }


  const content = (
    <NewBusMaintenanceStayForm onSubmit={onSubmit} />
  )

  const toolbar = (
    <Button
      type="button"
      className="pull-right mt-3"
      onClick={handleButtonClick}
    >Seleccionar Todos</Button>
  )

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Estancia de Mantenimiento por Bus"
      subtitle="Ingrese y/o seleccione los buses que estarán en mantenimiento"
      content={content}
      toolbar={toolbar}
    />
  );
};

NewBusMaintenanceStay.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostBusMaintenanceStay: PropTypes.func.isRequired,
  dispatchClearItineraryArrivals: PropTypes.func.isRequired,
  busMaintenanceStayBuseList: PropTypes.arrayOf(PropTypes.shape({})),
  dispatchChange: PropTypes.func.isRequired,
};

NewBusMaintenanceStay.defaultProps = {
  busMaintenanceStayBuseList: [],
};

const mapDispatchToProps = {
  dispatchPostBusMaintenanceStay: postBusMaintenanceStay,
  dispatchClearItineraryArrivals: clearItineraryArrivals,
  dispatchChange: change,
};

const mapStateToProps = (state) => {

  const formValues = formValuesSelector(state) || {};


  return ({
    breadcrumbs: [
      ...state.MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
      {
        text: 'Estancias de Mantenimiento por Bus',
        href: BUS_MAINTENANCE_STAY_PATH,
      },
      {
        text: 'Nuevo',
        href: '',
      },
    ],
    busMaintenanceStayBuseList: formValues.busMaintenanceStayBuses || [],
  })
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewBusMaintenanceStay);
